import * as angular from 'angular';
import 'angular-file-saver';
import 'angular-ui-router';
import permissions from 'application/detail/permissions.json';
import { actionTabComponents } from 'modules/application/detail/portal-submodule-builder/templates/builder/tabs/actions/components';
import { contentTabComponents } from 'modules/application/detail/portal-submodule-builder/templates/builder/tabs/content/components';
import { outputsTabComponents } from 'modules/application/detail/portal-submodule-builder/templates/builder/tabs/outputs/components';
import { MessageService } from 'modules/message/MessageService';
import { BuilderQueuesComponent } from './attendanceRules/queues';
import { BuilderRulesComponent } from './attendanceRules/rules';
import { BuilderController } from './BuilderController';
import BuilderView from './BuilderView.html';
import { BuilderNodeComponent } from './components/builderNode/builderNode.component';
import { BuilderNodeTagsComponent } from './components/builderNodeTags/builderNodeTags.component';
import { BuilderSearchComponent } from './components/builderSearch/builderSearch.component';
import { ActionContentService } from './services/ActionContentService';
import { BuilderContentService } from './services/BuilderContentService';
import { BuilderSegmentService } from './services/BuilderSegmentService';
import { BuilderService } from './services/BuilderService';
import { AiAgentService } from 'modules/application/misc/AiAgentService';
import { BuilderAiAgentService } from './services/BuilderAiAgentService';
import { LockService } from './services/LockService';
import { BuilderStateService } from './services/BuilderStateService';
import { BuilderTabsService } from './services/BuilderTabsService';
import { CodeEditorService } from './services/CodeEditor/CodeEditorService';
import { JsPlumbService } from './services/JsPlumbService';
import { SavingService } from './services/SavingService';
import { SubflowService } from './services/SubflowService';
import { SmartSalesService } from './services/SmartSalesService';
import { TagsService } from './services/TagsService';
import { VariablesService } from './services/VariablesService';
import { CopilotAdapterService } from './services/CopilotAdapterService';
import { BuilderInfoHeaderComponent } from './components/builderInfoHeader/builderInfoHeader.component';
import { BuilderAutocompleteComponent } from './components/builderAutocomplete/builderAutocomplete.component';
import { ExclusiveComponentsService } from './services/ExclusiveComponentsService';
import { WidgetHelpBuilderComponent } from './widgetHelpCenterBuilder/Index';
import { FunctionService } from './services/FunctionService';
import { ActionService } from './services/ActionService';
import { BuilderSecondColumnSidebarComponent } from './components/builderSecondCollumnSidebar/builderSecondCollumnSidebar.component';
import { BuilderModalBannerComponent } from './components/builderModalBanner/builderModalBanner.component';
import { ChatBrainService } from './services/ChatBrainService';
import { aiAgentModule } from './aiAgent';
import { paymentModule } from './payment';
import { studioModule } from './studio';
// Constants
export const builderStateName = 'auth.application.detail.builder.index';
export const builderDefaultStateName = 'auth.application.detail.builder';
export const templateBuilder = angular
    .module('builder', ['ngFileSaver', contentTabComponents, actionTabComponents, outputsTabComponents, aiAgentModule, paymentModule, studioModule])
    .service('SubflowService', SubflowService)
    .service('SmartSalesService', SmartSalesService)
    .service('ExclusiveComponentsService', ExclusiveComponentsService)
    .service('LockService', LockService)
    .service('BuilderService', BuilderService)
    .service('FunctionService', FunctionService)
    .service('ActionService', ActionService)
    .service('BuilderStateService', BuilderStateService)
    .service('JsPlumbService', JsPlumbService)
    .service('SavingService', SavingService)
    .service('BuilderContentService', BuilderContentService)
    .service('MessageService', MessageService)
    .service('TagsService', TagsService)
    .service('VariablesService', VariablesService)
    .service('CodeEditorService', CodeEditorService)
    .service('BuilderSegmentService', BuilderSegmentService)
    .service('BuilderTabsService', BuilderTabsService)
    .service('ActionContentService', ActionContentService)
    .service('CopilotAdapterService', CopilotAdapterService)
    .service('BuilderAiAgentService', BuilderAiAgentService)
    .service('ChatBrainService', ChatBrainService)
    .component('builderNode', BuilderNodeComponent)
    .component('builderInfoHeader', BuilderInfoHeaderComponent)
    .component('builderAutocomplete', BuilderAutocompleteComponent)
    .component('widgetHelpBuilder', WidgetHelpBuilderComponent)
    .component('builderSearch', BuilderSearchComponent)
    .component('builderNodeTags', BuilderNodeTagsComponent)
    .component('builderAttendanceQueue', BuilderQueuesComponent)
    .component('builderAttendanceRules', BuilderRulesComponent)
    .component('builderSecondColumnSidebar', BuilderSecondColumnSidebarComponent)
    .component('builderModalBanner', BuilderModalBannerComponent)
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider
            .state(builderDefaultStateName, {
            url: '/templates/builder?appcue&selectedNodeId',
            redirectTo: builderStateName,
            data: {
                permissionClaim: permissions.builder.claim,
            },
        })
            .state(builderStateName, {
            url: '/:callerSubflow',
            views: {
                'content@auth.application.detail': {
                    template: BuilderView,
                    controller: BuilderController,
                    controllerAs: '$ctrl',
                },
            },
            resolve: {
                loadJsplumb: ['$q', ($q) => {
                        const deferred = $q.defer();
                        import(/* webpackChunkName: "jsplumb" */ 'jsplumb')
                            .then((script) => {
                            deferred.resolve(script);
                        })
                            .catch((e) => {
                            console.error(e);
                        });
                        return deferred.promise;
                    }],
                checkLayout: AiAgentService.blockAiAgentAccess,
            },
            params: { area: 'builder' },
        });
    }]).name;
